var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader'),_vm._v(" "),(!_vm.habilitado)?_c('no-habilitado',{attrs:{"perfil":"Administradores"}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('app-error',{attrs:{"errorMensaje":_vm.errorMensaje}}):_vm._e(),_vm._v(" "),_c('h1',{staticStyle:{"margin-top":"100px","margin-left":"50px"}},[_vm._v("Administrar categorias")]),_vm._v(" "),_c('app-categories-grid')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da07fe14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminCategories.vue
// module id = 521
// module chunks = 0